.filtersContainer {
  display: flex;
  flex-wrap: wrap;
  gap: 20px;
  align-items: flex-start;
}

.filterGroup {
  display: flex;
  align-items: center;
  gap: 8px;
  flex-wrap: wrap;
}

.filterLabel {
  font-size: 13px;
  font-weight: 400;
  color: #707070;
  white-space: nowrap;
}

.chips {
  display: flex;
  gap: 6px;
  flex-wrap: wrap;
}

.chip {
  padding: 6px 14px;
  font-size: 13px;
  font-weight: 400;
  color: #505050;
  background: #f5f3ef;
  border: 1px solid #e0ddd8;
  border-radius: 999px;
  cursor: pointer;
  transition:
    background 0.15s ease,
    border-color 0.15s ease,
    color 0.15s ease;
  white-space: nowrap;
}

.chip:hover {
  background: #eae7e1;
  border-color: #c0bdb8;
}

.chipActive {
  background: #505050;
  color: white;
  border-color: #505050;
}

.chipActive:hover {
  background: #3a3a3a;
  border-color: #3a3a3a;
}

@media (max-width: 768px) {
  .filtersContainer {
    gap: 12px;
  }

  .filterGroup {
    gap: 6px;
  }

  .chip {
    padding: 5px 10px;
    font-size: 12px;
  }

  .filterLabel {
    font-size: 12px;
  }
}
